import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { common } from 'src/app/app.common';
import { Router, ActivatedRoute } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, FormBuilder, Validators, MaxLengthValidator, } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ThoiHocNgungHocService } from 'src/app/Utils/services/thoi-hoc-ngung-hoc.service';
import { AllService } from 'src/app/Utils/services/all.service';
import { DataTablesModule } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { formatValidator } from '@angular-devkit/schematics/src/formats/format-validator';
import { forEach } from '@angular-devkit/schematics';
import { timeout } from 'rxjs/operators';
import { AbstractControl } from '@angular/forms';
@Component({
  selector: 'app-thoi-hoc-ngung-hoc',
  templateUrl: './thoi-hoc-ngung-hoc.component.html',
  styleUrls: ['./thoi-hoc-ngung-hoc.component.scss']
})
export class ThoiHocNgungHocComponent implements OnInit {
  public com: common
  Token: any
  listID_lop: string
  dataKhoaHoc2: any = []
  dataChuyenNganh2: any = []
  dataLop2: any = []
  Nam_hoc_arr: any = []
  dataHe: any = []
  dataKhoa: any = []
  dataKhoaHoc: any = []
  dataChuyenNganh: any = []
  dataLop: any = []
  dataBienDongSV: any = []
  headBienDongSV: any = []
  dataSiSoTheoHe: any = []
  dataSiSoTheoKhoa: any = []
  dataSiSoTheoNganh: any = []
  dataSiSoTheoLop: any = []
  isDisplayBDSV: boolean = false
  isDisplaySSTheoHe: boolean = false
  isDisplaySSTheoKhoa: boolean = false
  isDisplaySSTheoNganh: boolean = false
  isDisplaySSTheoLop: boolean = false

  constructor(
    private modalService: NgbModal,
    private ThoiHocNgungHocService: ThoiHocNgungHocService,
    private AllService: AllService,
    public router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
  ) { }
  filter = new FormGroup({
    Hoc_ky: new FormControl(""),
    Nam_hoc: new FormControl((new Date().getFullYear() - 1)+ '-' + new Date().getFullYear()),
    ID_he: new FormControl(null),
    ID_khoa: new FormControl(""),
    ID_lop: new FormControl(""),
    ID_chuyen_nganh: new FormControl(""),
    Khoa_hoc: new FormControl(""),
  });
  ngOnInit(): void {
    let element, name, arr
    element = document.getElementById('menu1')
    arr = element.className.split(' ')
    name = 'menu-open'
    if (arr.indexOf(name) == -1) {
      element.className += ' ' + name
    }
    var yearNow = new Date().getFullYear() + 4;
    for (var i = 0; i < 10; i++) {
      let Nam_hoc_string = yearNow + '-' + (yearNow + 1);
      let object = {
        value: Nam_hoc_string,
        name: Nam_hoc_string,
      };
      this.Nam_hoc_arr.push(object);
      yearNow--;
    }
    this.com = new common(this.router)
    this.com.CheckLogin();
    var a = this.com.getUserinfo()
    this.Token = a.Token

    this.getList()
  }
  getList() {
    this.spinner.show()
    let IDhe;
    let IDKhoahoc;
    this.AllService.getHe(this.Token).subscribe((z) => {
      this.dataHe = z
      IDhe = z[0].ID_he
      this.filter.patchValue({ ID_he: z[0].ID_he });
      this.AllService.getKhoa(this.Token).subscribe((z) => {
        this.dataKhoa = z
        this.AllService.getKhoaHoc(this.Token).subscribe((z) => {
          this.dataKhoaHoc = z.Data
          this.dataKhoaHoc2 = this.dataKhoaHoc.filter(i => i.ID_he == IDhe);
          this.dataKhoaHoc2 = this.dataKhoaHoc2.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);

          this.AllService.getLop(this.Token).subscribe((z) => {
            this.dataChuyenNganh = z
            this.dataChuyenNganh2 = this.dataChuyenNganh
            this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.ID_he == IDhe);
            this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
            this.dataLop = z
            this.dataLop2 = this.dataLop.filter(i => i.ID_he == IDhe);
          });
          this.spinner.hide()
        });
      });
    });
  }
  changeHe() {
    this.dataKhoaHoc2 = this.dataKhoaHoc.filter(i => i.ID_he == this.filter.value.ID_he);
    this.dataKhoaHoc2 = this.dataKhoaHoc2.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);
    this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
    this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
    this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
  }
  changeKhoa() {
    if (this.filter.value.ID_khoa != "") {
      this.dataKhoaHoc2 = this.dataKhoaHoc.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);
      this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
    } else {
      this.dataKhoaHoc2 = this.dataKhoaHoc.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);
      this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
    }
  }
  changeKhoaHoc() {
    if (this.filter.value.Khoa_hoc != "") {
      this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.Khoa_hoc == parseInt(this.filter.value.Khoa_hoc));
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      this.dataLop2 = this.dataLop2.filter(i => i.Khoa_hoc == parseInt(this.filter.value.Khoa_hoc));
    } else {
      this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
    }

  }
  changeChuyenNganh() {
    if (this.filter.value.ID_chuyen_nganh != "") {
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      if (this.filter.value.Khoa_hoc != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.Khoa_hoc == parseInt(this.filter.value.Khoa_hoc));
      }
      this.dataLop2 = this.dataLop2.filter(i => i.ID_chuyen_nganh == this.filter.value.ID_chuyen_nganh);
    } else {
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      if (this.filter.value.Khoa_hoc != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.Khoa_hoc == parseInt(this.filter.value.Khoa_hoc));
      }
    }
  
  }
  bienDongSV() {
    this.listID_lop = ""
    if (this.filter.value.ID_lop == "") {
      this.dataLop2.forEach(element => {
        this.listID_lop += element.ID_lop + ","
      });
    } else {
      this.listID_lop = this.filter.value.ID_lop
    }
    this.listID_lop = this.listID_lop + "0"
    if (this.filter.value.Nam_hoc == "") {
      this.toastr.warning("Bạn chưa chọn Học kỳ, Năm học!")
      return false
    }
    this.isDisplayBDSV = true
    this.isDisplaySSTheoHe = false
    this.isDisplaySSTheoKhoa = false
    this.isDisplaySSTheoNganh = false
    this.isDisplaySSTheoLop = false
    this.spinner.show()
    let req = {
      dsID_lop: this.listID_lop,
      Hoc_ky: this.filter.value.Hoc_ky,
      Nam_hoc: this.filter.value.Nam_hoc
    }
    this.ThoiHocNgungHocService.getBienDongSV(req, this.Token).subscribe((z) => {
      this.dataBienDongSV = z.Data
      this.headBienDongSV = z.Header
      this.spinner.hide();
    });
  }
  siSoTheoHe() {
    this.listID_lop = ""
    if (this.filter.value.ID_lop == "") {
      this.dataLop2.forEach(element => {
        this.listID_lop += element.ID_lop + ","
      });
    } else {
      this.listID_lop = this.filter.value.ID_lop + ","
    }
    this.listID_lop = this.listID_lop + "0"
    // if (this.filter.value.ID_he == "" ||this.filter.value.ID_khoa == ""|| this.filter.value.Nam_hoc == "") {
    //   this.toastr.warning("Bạn chưa chọn Hệ, Khoa, Năm học!")
    //   return false
    // }
    this.isDisplayBDSV = false
    this.isDisplaySSTheoHe = true
    this.isDisplaySSTheoKhoa = false
    this.isDisplaySSTheoNganh = false
    this.isDisplaySSTheoLop = false
    this.spinner.show()
    let req = {
      dsID_lop: this.listID_lop,
      Hoc_ky: this.filter.value.Hoc_ky,
      Nam_hoc: this.filter.value.Nam_hoc
    }
    this.ThoiHocNgungHocService.getSiSoTheoHe(req, this.Token).subscribe((z) => {
      console.log(z)
      this.dataSiSoTheoHe = z
      this.spinner.hide();
    });
  }
  siSoTheoKhoa() {
    this.listID_lop = ""
    if (this.filter.value.ID_lop == "") {
      this.dataLop2.forEach(element => {
        this.listID_lop += element.ID_lop + ","
      });
    } else {
      this.listID_lop = this.filter.value.ID_lop + ","
    }
    this.listID_lop = this.listID_lop + "0"
    this.isDisplayBDSV = false
    this.isDisplaySSTheoHe = false
    this.isDisplaySSTheoKhoa = true
    this.isDisplaySSTheoNganh = false
    this.isDisplaySSTheoLop = false
    this.spinner.show()
    let req = {
      dsID_lop: this.listID_lop,
      Hoc_ky: this.filter.value.Hoc_ky,
      Nam_hoc: this.filter.value.Nam_hoc
    }
    this.ThoiHocNgungHocService.getSiSoTheoKhoa(req, this.Token).subscribe((z) => {
      
      this.dataSiSoTheoKhoa = z.Data
      console.log(z)
      this.spinner.hide();
    });

  }
  siSoTheoNganh() {
    this.listID_lop = ""
    if (this.filter.value.ID_lop == "") {
      this.dataLop2.forEach(element => {
        this.listID_lop += element.ID_lop + ","
      });
    } else {
      this.listID_lop = this.filter.value.ID_lop + ","
    }
    this.listID_lop = this.listID_lop + "0"
    this.isDisplayBDSV = false
    this.isDisplaySSTheoHe = false
    this.isDisplaySSTheoKhoa = false
    this.isDisplaySSTheoNganh = true
    this.isDisplaySSTheoLop = false
    this.spinner.show()
    let req = {
      dsID_lop: this.listID_lop,
      Hoc_ky: this.filter.value.Hoc_ky,
      Nam_hoc: this.filter.value.Nam_hoc
    }
    this.ThoiHocNgungHocService.getSiSoTheoNganh(req, this.Token).subscribe((z) => {
      this.dataSiSoTheoNganh = z.Data
      console.log(z)
      this.spinner.hide();
    });
  }
  siSoTheoLop() {
    this.listID_lop = ""
    if (this.filter.value.ID_lop == "") {
      this.dataLop2.forEach(element => {
        this.listID_lop += element.ID_lop + ","
      });
    } else {
      this.listID_lop = this.filter.value.ID_lop 
    }
    if (this.filter.value.ID_he == "" ||this.filter.value.ID_khoa == ""|| this.filter.value.Khoa_hoc == ""|| this.filter.value.ID_chuyen_nganh == ""||this.filter.value.Nam_hoc == "") {
      this.toastr.warning("Bạn chưa chọn hệ, khoa, khóa, chuyên ngành, năm học!")
      return false
    }

    this.isDisplayBDSV = false
    this.isDisplaySSTheoHe = false
    this.isDisplaySSTheoKhoa = false
    this.isDisplaySSTheoNganh = false
    this.isDisplaySSTheoLop = true
    this.spinner.show()
    let req = {
      dsID_lop: this.listID_lop,
      Hoc_ky: this.filter.value.Hoc_ky,
      Nam_hoc: this.filter.value.Nam_hoc
    }
    this.ThoiHocNgungHocService.getSiSoTheoLop(req, this.Token).subscribe((z) => {
      this.dataSiSoTheoLop = z.Data
      this.spinner.hide();
    });

  }

}
